import { NavLink } from 'react-router-dom';
import { documentationNav } from '../content';

const baseLinkClasses =
  'flex items-start gap-3 rounded-2xl border px-4 py-4 text-left transition-all';

export function DocNavDesktop() {
  return (
    <aside className="hidden h-full w-72 shrink-0 border-r border-gray-200 bg-white px-5 py-8 xl:flex xl:flex-col">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gray-400">Documentation</p>
      <div className="mt-4 space-y-3">
        {documentationNav.map((page) => (
          <NavLink
            key={page.id}
            to={page.path ? `/documentation/${page.path}` : '/documentation'}
            end={!page.path}
            className={({ isActive }) =>
              `${baseLinkClasses} ${
                isActive
                  ? 'border-[#A6C7E9] bg-[#F4F7FC] shadow-sm'
                  : 'border-transparent hover:border-[#D4E2F4] hover:bg-[#F7FAFF]'
              }`
            }
          >
            <page.icon
              size={20}
              className="mt-1 flex-shrink-0 text-[#4A97AC]"
              aria-hidden="true"
            />
            <div className="space-y-1">
              <div className="text-sm font-semibold text-sb-black">{page.title}</div>
              <p className="text-xs text-gray-500">{page.description}</p>
            </div>
          </NavLink>
        ))}
      </div>
    </aside>
  );
}

export function DocNavMobile() {
  return (
    <div className="xl:hidden border-b border-gray-200 bg-white px-4 py-3 shadow-sm">
      <div className="flex gap-2 overflow-x-auto">
        {documentationNav.map((page) => (
          <NavLink
            key={page.id}
            to={page.path ? `/documentation/${page.path}` : '/documentation'}
            end={!page.path}
            className={({ isActive }) =>
              `flex items-center gap-2 rounded-full border px-4 py-2 text-xs font-semibold transition-colors ${
                isActive
                  ? 'border-[#A6C7E9] bg-[#EDF4FB] text-[#0F6B7C]'
                  : 'border-transparent bg-gray-100 text-gray-600'
              }`
            }
          >
            <page.icon size={14} />
            {page.title}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
